import { NavLink, useMatch } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useDesignVersionPath } from '@/hooks'

import { NAVIGATION_LABELS } from '../../helpers/constants'
import NavigationLabel from '../NavigationLabel/NavigationLabel'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'
import { selectUserRole } from '../../reducers/userDataReducer'

const DashModal = ({ activeBuilding }) => {
  const { t } = useTranslation(['navbar'])
  const buildingId = activeBuilding?.id || ''
  const userRole = useSelector(selectUserRole)
  const staffPath = useDesignVersionPath('staff', {
    legacy: '/dashboard/organisation/staff/legacy',
    new: '/dashboard/organisation/staff',
  })
  const managersPath = useDesignVersionPath('managers', {
    legacy: '/dashboard/organisation/managers/legacy',
    new: '/dashboard/organisation/managers',
  })
  const placesPath = useDesignVersionPath('places', {
    legacy: '/dashboard/organisation/places/legacy',
    new: '/dashboard/organisation/places',
  })
  const isPlacesExact = !!useMatch(placesPath)
  const servicesPath = useDesignVersionPath('services', {
    legacy: '/dashboard/organisation/services/legacy',
    new: '/dashboard/organisation/services',
  })
  const bookingTypesPath = useDesignVersionPath('booking-types', {
    legacy: '/dashboard/organisation/bookingtypes/legacy',
    new: '/dashboard/organisation/bookingtypes',
  })
  const propertyManagersPath = useDesignVersionPath('property-managers', {
    legacy: '/dashboard/organisation/property-managers/legacy',
    new: '/dashboard/organisation/property-managers',
  })

  return (
    <div className="navmgr-hover-menu-dash">
      <div className="hover-menu-arrow" />
      <div className="navmgr-hover-menu__inner">
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
            }
            to={`/dashboard/building-dashboard/home-screen${buildingId ? `/${buildingId}` : ''}`}
          >
            <span>
              {t('navbar:dashModal.homeScreen')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
            }
            to={staffPath}
          >
            <span>
              {t('navbar:dashModal.staff')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        {userRole === 'Administrator' && (
          <div className="hover-menu-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
              }
              to={managersPath}
            >
              <span>
                {t('navbar:dashModal.managers')}
                <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
              </span>
            </NavLink>
          </div>
        )}
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
            }
            to={propertyManagersPath}
          >
            <span>
              {t('navbar:dashModal.propertyManagers')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
            }
            to={servicesPath}
          >
            <span>
              {t('navbar:dashModal.services')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
            }
            to={bookingTypesPath}
          >
            <span>
              {t('navbar:dashModal.bookingTypes')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        <div className="hover-menu-item">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? `navmgr-item__link--active${isPlacesExact ? '' : ' navmgr-item__link--parent'}`
                : 'hover-menu-item__link'
            }
            to={placesPath}
          >
            <span>
              {t('navbar:dashModal.places')}
              <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
            </span>
          </NavLink>
        </div>
        {userRole === 'Administrator' && (
          <div className="hover-menu-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
              }
              to="/dashboard/beta"
            >
              <span>
                {t('navbar:dashModal.beta')}
                <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} />
              </span>
            </NavLink>
          </div>
        )}
      </div>
    </div>
  )
}

DashModal.propTypes = {
  activeBuilding: PropTypes.object,
}

export default connect((state) => ({
  activeBuilding: selectActiveBuilding(state),
}))(DashModal)
